import { render } from "./Auth.vue?vue&type=template&id=066698f4"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=066698f4&lang=sass"

import exportComponent from "/home/runner/work/wiki.zems.pro/wiki.zems.pro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__